import round from "lodash/round";

export const setPercentage = (a: number, b: number) => {
  return (a !== b && round((a / b) * 100, 2)) || 0;
};
